import { typedAction } from "../actionTypes";
import {
  LOYALTY_ENROLL_REQUEST, LOYALTY_ENROLL_SUCCESS, LOYALTY_ENROLL_ERROR,
  LOYALTY_LOOKUP_REQUEST, LOYALTY_LOOKUP_SUCCESS, LOYALTY_LOOKUP_ERROR, LOYALTY_LOOKUP_CLEAR,
  LOYALTY_DASHBOARD_REQUEST, LOYALTY_DASHBOARD_SUCCESS, LOYALTY_DASHBOARD_ERROR,
  LOYALTY_PROGRAM_EXISTS_REQUEST, LOYALTY_PROGRAM_EXISTS_SUCCESS, LOYALTY_PROGRAM_EXISTS_ERROR,
  LOYALTY_AVAILABLE_REWARDS_REQUEST, LOYALTY_AVAILABLE_REWARDS_SUCCESS, LOYALTY_AVAILABLE_REWARDS_ERROR,
  LOYALTY_APPLY_REWARD_REQUEST, LOYALTY_APPLY_REWARD_SUCCESS, LOYALTY_APPLY_REWARD_ERROR,
  LOYALTY_SET_APPLIED_REDEMPTIONS,
  LOYALTY_REMOVE_REWARD_REQUEST, LOYALTY_REMOVE_REWARD_SUCCESS, LOYALTY_REMOVE_REWARD_ERROR,
  LOYALTY_POINTS_PREVIEW_REQUEST, LOYALTY_POINTS_PREVIEW_SUCCESS, LOYALTY_POINTS_PREVIEW_ERROR,
  LOYALTY_ORDER_IDENTIFY_REQUEST, LOYALTY_ORDER_IDENTIFY_SUCCESS, LOYALTY_ORDER_IDENTIFY_ERROR,
  LOYALTY_CHECKOUT_SUMMARY_REQUEST, LOYALTY_CHECKOUT_SUMMARY_SUCCESS, LOYALTY_CHECKOUT_SUMMARY_ERROR,
  LOYALTY_ORDER_COMPLETE_REQUEST, LOYALTY_ORDER_COMPLETE_SUCCESS, LOYALTY_ORDER_COMPLETE_ERROR,
  LOYALTY_ACCRUE_POINTS_REQUEST, LOYALTY_ACCRUE_POINTS_SUCCESS, LOYALTY_ACCRUE_POINTS_ERROR,
  LOYALTY_ACCRUE_IN_FLIGHT,
  LOYALTY_ACTIVE_PROMOS_SUCCESS, LOYALTY_ACTIVE_PROMOS_ERROR,
  LOYALTY_RECEIPT_DATA_REQUEST, LOYALTY_RECEIPT_DATA_SUCCESS, LOYALTY_RECEIPT_DATA_ERROR,
  LOYALTY_WALLET_PASS_GENERATE_REQUEST, LOYALTY_WALLET_PASS_GENERATE_SUCCESS, LOYALTY_WALLET_PASS_GENERATE_ERROR,
  LOYALTY_WALLET_PASS_GET_REQUEST, LOYALTY_WALLET_PASS_GET_SUCCESS, LOYALTY_WALLET_PASS_GET_ERROR,
  LOYALTY_RESET,
  LOYALTY_INVALIDATE_CACHE,
  LOYALTY_SET_SKIP_FOR_ORDER,
  LOYALTY_CUSTOMER_TRANSACTIONS_REQUEST, LOYALTY_CUSTOMER_TRANSACTIONS_SUCCESS, LOYALTY_CUSTOMER_TRANSACTIONS_ERROR,
  LOYALTY_SET_POINTS_TO_REDEEM,
} from "./loyaltyConstants";
import {
  LoyaltyEnrollRequest, LoyaltyEnrollResponse,
  LoyaltyLookupResult, LoyaltyDashboard,
  LoyaltyAvailableRewardsResponse, LoyaltyApplyRewardRequest, LoyaltyApplyRewardResponse,
  LoyaltyAppliedRedemption,
  LoyaltyPointsPreviewRequest, LoyaltyPointsPreview,
  LoyaltyOrderIdentifyRequest, LoyaltyCheckoutSummary,
  LoyaltyOrderCompleteRequest, LoyaltyOrderCompleteResponse,
  LoyaltyAccruePointsRequest, LoyaltyAccruePointsResponse,
  LoyaltyActivePromotion, LoyaltyReceiptData, LoyaltyWalletPass,
  LoyaltyTransaction,
} from "./loyaltyModels";

// ─── Enrollment ───────────────────────────────────────
export const requestLoyaltyEnroll = (data: LoyaltyEnrollRequest) => typedAction(LOYALTY_ENROLL_REQUEST, data);
export const successLoyaltyEnroll = (data: LoyaltyEnrollResponse) => typedAction(LOYALTY_ENROLL_SUCCESS, data);
export const errorLoyaltyEnroll = () => typedAction(LOYALTY_ENROLL_ERROR);

// ─── Lookup ───────────────────────────────────────────
export const requestLoyaltyLookup = (data: { phone: string; locationId: string }) => typedAction(LOYALTY_LOOKUP_REQUEST, data);
export const successLoyaltyLookup = (data: LoyaltyLookupResult) => typedAction(LOYALTY_LOOKUP_SUCCESS, data);
export const errorLoyaltyLookup = () => typedAction(LOYALTY_LOOKUP_ERROR);
export const clearLoyaltyLookup = () => typedAction(LOYALTY_LOOKUP_CLEAR);

// ─── Dashboard ────────────────────────────────────────
export const requestLoyaltyDashboard = (data: { loyaltyCustomerId: string; locationId: string }) => typedAction(LOYALTY_DASHBOARD_REQUEST, data);
export const successLoyaltyDashboard = (data: LoyaltyDashboard) => typedAction(LOYALTY_DASHBOARD_SUCCESS, data);
export const errorLoyaltyDashboard = () => typedAction(LOYALTY_DASHBOARD_ERROR);

// ─── Program Exists by Location ───────────────────────
export const requestLoyaltyProgramExists = (locationId: string) => typedAction(LOYALTY_PROGRAM_EXISTS_REQUEST, locationId);
export const successLoyaltyProgramExists = (data: { brand_has_program: boolean; location_has_program: boolean; program_status: string | null }) =>
  typedAction(LOYALTY_PROGRAM_EXISTS_SUCCESS, data);
export const errorLoyaltyProgramExists = () => typedAction(LOYALTY_PROGRAM_EXISTS_ERROR);

// ─── Available Rewards ────────────────────────────────
export const requestLoyaltyAvailableRewards = (data: { loyaltyCustomerId: string; locationId: string; orderTotal?: number; orderId?: string }) => typedAction(LOYALTY_AVAILABLE_REWARDS_REQUEST, data);
export const successLoyaltyAvailableRewards = (data: LoyaltyAvailableRewardsResponse) => typedAction(LOYALTY_AVAILABLE_REWARDS_SUCCESS, data);
export const errorLoyaltyAvailableRewards = () => typedAction(LOYALTY_AVAILABLE_REWARDS_ERROR);

// ─── Apply Reward ─────────────────────────────────────
export const requestLoyaltyApplyReward = (data: { orderId: string; payload: LoyaltyApplyRewardRequest }) => typedAction(LOYALTY_APPLY_REWARD_REQUEST, data);
export const successLoyaltyApplyReward = (data: LoyaltyApplyRewardResponse) => typedAction(LOYALTY_APPLY_REWARD_SUCCESS, data);
export const errorLoyaltyApplyReward = (msg: string) => typedAction(LOYALTY_APPLY_REWARD_ERROR, msg);
// Stores the full list of applied redemptions on the active order. The saga dispatches this from
// both single and bulk redeem responses so the panel can hydrate its remove-button mapping.
export const setLoyaltyAppliedRedemptions = (data: LoyaltyAppliedRedemption[]) => typedAction(LOYALTY_SET_APPLIED_REDEMPTIONS, data);

// ─── Remove Reward ────────────────────────────────────
export const requestLoyaltyRemoveReward = (data: { orderId: string; applicationId: string; loyaltyCustomerId?: string; locationId?: string }) => typedAction(LOYALTY_REMOVE_REWARD_REQUEST, data);
export const successLoyaltyRemoveReward = (data: any) => typedAction(LOYALTY_REMOVE_REWARD_SUCCESS, data);
export const errorLoyaltyRemoveReward = () => typedAction(LOYALTY_REMOVE_REWARD_ERROR);

// ─── Points Preview ───────────────────────────────────
export const requestLoyaltyPointsPreview = (data: { orderId: string; payload: LoyaltyPointsPreviewRequest }) => typedAction(LOYALTY_POINTS_PREVIEW_REQUEST, data);
export const successLoyaltyPointsPreview = (data: LoyaltyPointsPreview) => typedAction(LOYALTY_POINTS_PREVIEW_SUCCESS, data);
export const errorLoyaltyPointsPreview = () => typedAction(LOYALTY_POINTS_PREVIEW_ERROR);

// ─── Order Identify ───────────────────────────────────
export const requestLoyaltyOrderIdentify = (data: LoyaltyOrderIdentifyRequest) => typedAction(LOYALTY_ORDER_IDENTIFY_REQUEST, data);
export const successLoyaltyOrderIdentify = (data: any) => typedAction(LOYALTY_ORDER_IDENTIFY_SUCCESS, data);
export const errorLoyaltyOrderIdentify = () => typedAction(LOYALTY_ORDER_IDENTIFY_ERROR);

// ─── Checkout Summary ─────────────────────────────────
export const requestLoyaltyCheckoutSummary = (data: { orderId: string; locationId: string }) => typedAction(LOYALTY_CHECKOUT_SUMMARY_REQUEST, data);
export const successLoyaltyCheckoutSummary = (data: LoyaltyCheckoutSummary) => typedAction(LOYALTY_CHECKOUT_SUMMARY_SUCCESS, data);
export const errorLoyaltyCheckoutSummary = () => typedAction(LOYALTY_CHECKOUT_SUMMARY_ERROR);

// ─── Order Complete ───────────────────────────────────
export const requestLoyaltyOrderComplete = (data: { orderId: string; payload: LoyaltyOrderCompleteRequest }) => typedAction(LOYALTY_ORDER_COMPLETE_REQUEST, data);
export const successLoyaltyOrderComplete = (data: LoyaltyOrderCompleteResponse) => typedAction(LOYALTY_ORDER_COMPLETE_SUCCESS, data);
export const errorLoyaltyOrderComplete = () => typedAction(LOYALTY_ORDER_COMPLETE_ERROR);

// ─── Accrue Points (post-payment) ─────────────────────
export const loyaltyAccrueInFlight = () => typedAction(LOYALTY_ACCRUE_IN_FLIGHT);
export const requestLoyaltyAccruePoints = (data: LoyaltyAccruePointsRequest) => typedAction(LOYALTY_ACCRUE_POINTS_REQUEST, data);
export const successLoyaltyAccruePoints = (data: LoyaltyAccruePointsResponse) => typedAction(LOYALTY_ACCRUE_POINTS_SUCCESS, data);
export const errorLoyaltyAccruePoints = (msg: string) => typedAction(LOYALTY_ACCRUE_POINTS_ERROR, msg);

// ─── Active Promotions ────────────────────────────────
export const successLoyaltyActivePromos = (data: LoyaltyActivePromotion[]) => typedAction(LOYALTY_ACTIVE_PROMOS_SUCCESS, data);
export const errorLoyaltyActivePromos = (noProgram?: boolean) => typedAction(LOYALTY_ACTIVE_PROMOS_ERROR, noProgram);

// ─── Receipt Data ─────────────────────────────────────
export const requestLoyaltyReceiptData = (orderId: string) => typedAction(LOYALTY_RECEIPT_DATA_REQUEST, orderId);
export const successLoyaltyReceiptData = (data: LoyaltyReceiptData) => typedAction(LOYALTY_RECEIPT_DATA_SUCCESS, data);
export const errorLoyaltyReceiptData = () => typedAction(LOYALTY_RECEIPT_DATA_ERROR);

// ─── Wallet Pass ──────────────────────────────────────
export const requestLoyaltyGenerateWalletPass = (data: { loyaltyCustomerId: string; passType: "apple" | "google"; programId: string }) => typedAction(LOYALTY_WALLET_PASS_GENERATE_REQUEST, data);
export const successLoyaltyGenerateWalletPass = (data: LoyaltyWalletPass) => typedAction(LOYALTY_WALLET_PASS_GENERATE_SUCCESS, data);
export const errorLoyaltyGenerateWalletPass = () => typedAction(LOYALTY_WALLET_PASS_GENERATE_ERROR);

export const requestLoyaltyGetWalletPass = (loyaltyCustomerId: string) => typedAction(LOYALTY_WALLET_PASS_GET_REQUEST, loyaltyCustomerId);
export const successLoyaltyGetWalletPass = (data: LoyaltyWalletPass) => typedAction(LOYALTY_WALLET_PASS_GET_SUCCESS, data);
export const errorLoyaltyGetWalletPass = () => typedAction(LOYALTY_WALLET_PASS_GET_ERROR);

// ─── Reset ────────────────────────────────────────────
export const resetLoyalty = () => typedAction(LOYALTY_RESET);
export const invalidateLoyaltyCache = () => typedAction(LOYALTY_INVALIDATE_CACHE);

// ─── Customer Transactions (full history) ─────────────
export const requestLoyaltyCustomerTransactions = (loyaltyCustomerId: string) => typedAction(LOYALTY_CUSTOMER_TRANSACTIONS_REQUEST, loyaltyCustomerId);
export const successLoyaltyCustomerTransactions = (data: { transactions: LoyaltyTransaction[]; pointsName: string }) => typedAction(LOYALTY_CUSTOMER_TRANSACTIONS_SUCCESS, data);
export const errorLoyaltyCustomerTransactions = () => typedAction(LOYALTY_CUSTOMER_TRANSACTIONS_ERROR);

// ─── Pay-at-Store / Pay-on-Delivery skip flag ─────────
// Set to `true` by handleOfflinePay before placeOrder runs. The cart saga reads it inside
// dispatchLoyaltyAccrueAfterOrder to skip the accrue API, and CartRewardsRedeemPanel's
// orderId-arrival effect reads it to skip the apply-reward (redeem) API. The panel effect
// resets it back to false after consuming so the next online order isn't affected.
export const setSkipLoyaltyForOrder = (skip: boolean) => typedAction(LOYALTY_SET_SKIP_FOR_ORDER, skip);

// ─── Points to Redeem ─────────────────────────────────
export const setLoyaltyPointsToRedeem = (points: number | null) => typedAction(LOYALTY_SET_POINTS_TO_REDEEM, points);

export type LoyaltyActions = ReturnType<
  | typeof requestLoyaltyEnroll | typeof successLoyaltyEnroll | typeof errorLoyaltyEnroll
  | typeof requestLoyaltyLookup | typeof successLoyaltyLookup | typeof errorLoyaltyLookup | typeof clearLoyaltyLookup
  | typeof requestLoyaltyDashboard | typeof successLoyaltyDashboard | typeof errorLoyaltyDashboard
  | typeof requestLoyaltyProgramExists | typeof successLoyaltyProgramExists | typeof errorLoyaltyProgramExists
  | typeof requestLoyaltyAvailableRewards | typeof successLoyaltyAvailableRewards | typeof errorLoyaltyAvailableRewards
  | typeof requestLoyaltyApplyReward | typeof successLoyaltyApplyReward | typeof errorLoyaltyApplyReward
  | typeof setLoyaltyAppliedRedemptions
  | typeof requestLoyaltyRemoveReward | typeof successLoyaltyRemoveReward | typeof errorLoyaltyRemoveReward
  | typeof requestLoyaltyPointsPreview | typeof successLoyaltyPointsPreview | typeof errorLoyaltyPointsPreview
  | typeof requestLoyaltyOrderIdentify | typeof successLoyaltyOrderIdentify | typeof errorLoyaltyOrderIdentify
  | typeof requestLoyaltyCheckoutSummary | typeof successLoyaltyCheckoutSummary | typeof errorLoyaltyCheckoutSummary
  | typeof requestLoyaltyOrderComplete | typeof successLoyaltyOrderComplete | typeof errorLoyaltyOrderComplete
  | typeof loyaltyAccrueInFlight | typeof requestLoyaltyAccruePoints | typeof successLoyaltyAccruePoints | typeof errorLoyaltyAccruePoints
  | typeof successLoyaltyActivePromos | typeof errorLoyaltyActivePromos
  | typeof requestLoyaltyReceiptData | typeof successLoyaltyReceiptData | typeof errorLoyaltyReceiptData
  | typeof requestLoyaltyGenerateWalletPass | typeof successLoyaltyGenerateWalletPass | typeof errorLoyaltyGenerateWalletPass
  | typeof requestLoyaltyGetWalletPass | typeof successLoyaltyGetWalletPass | typeof errorLoyaltyGetWalletPass
  | typeof resetLoyalty
  | typeof invalidateLoyaltyCache
  | typeof setSkipLoyaltyForOrder
  | typeof requestLoyaltyCustomerTransactions | typeof successLoyaltyCustomerTransactions | typeof errorLoyaltyCustomerTransactions
  | typeof setLoyaltyPointsToRedeem
>;
